export default class LifeReevaluationOption {
  code?: string
  description: string
  value: string

  constructor(data: LifeReevaluationOption) {
    this.code = data.code
    this.description = data.description
    this.value = data.value
  }
}
